<template>
  <div>
    <!-- 抽屉 -->
    <el-drawer
    :append-to-body="true"
      class="drawer"
      title="请选择设备"
      :visible.sync="drawerFlag"
      :before-close="handleClose">
      <div class="container">
        <el-row class="screen" :span="24">
          <el-col :span="8">
            <el-select v-model="versionValue"
            placeholder="请选择"
            multiple class="sel"
            collapse-tags
            @change="selChange"
            :disabled="popData.firmwareType=== 1 ? true: false">
              <el-option
                v-for="item in versionOptions"
                :key="item.moduleVersion"
                :label="item.moduleVersion"
                :value="item.moduleVersion">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="16">
            <el-input placeholder="请输入设备名称" v-model.trim="deviceInput" @keyup.13.native="drawerHandlerKeyUp" class="inp"  >
              <el-button slot="append" icon="el-icon-search" @click="drawerDemand"></el-button>
            </el-input>
          </el-col>
          <!-- <el-col :span="3">
            <el-button type="primary" class="leftBtn">全部</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary"  class="rightBtn">已选</el-button>
          </el-col> -->
        </el-row>
         <el-table
          ref="multipleTable"
          :data="versionTableData"
          :row-key="getRowKeys"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          @selection-change="handleSelectionChange">
          <el-table-column
          :reserve-selection="true"
            type="selection">
          </el-table-column>
          <el-table-column
            prop="deviceName"
            label="DeviceName"
            >
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column
            prop="productKey"
            label="productKey"
            >
          </el-table-column>
          <el-table-column
            prop="moduleVersion"
            label="版本号"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <Paging :total="total" :pagingStatus="pagingStatus" @changePage="changePage"/>
      </div>
      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="confirm"
          >
            确定
          </el-button>
          <el-button @click="cancel" >取消</el-button>
        </div>
       <!--  <span>
          已选择 <i>{{count}}</i> 个设备
        </span> -->
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getDevices } from '@/api/productControl.js'
import Paging from '@/components/paging'
// import Bus from '@/assets/js/eventBus.js'
export default {
  props: {
    popData: {
      type: Object,
      default: null
    },
    popDate: {
      type: Number
    },
    versionOptions: {
      type: Array
    },
    ids: { // 回显数据
      type: Array
    },
    vValue: { // 回显的版本号
      type: Array
    },
    drawerFlag: {
      type: Boolean
    }
  },
  components: {
    Paging
  },
  data () {
    return {
      pagingStatus: '',
      // 分页功能
      total: 5, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      deviceInput: '', // 设备名称
      versionValue: [], // 版本号
      // versionOptions: [],
      versionTableData: [],
      multipleSelection: [], // 选择框选的数量
      count: 0,
      keysArr: []
    }
  },
  created () {
    console.log(this.versionOptions)
    console.log('需回显的数据', this.ids)
    console.log(this.popData, this.popDate)
    console.log(this.vValue)
    this.popData.firmwareType === 1 ? this.versionValue.push(this.popData.sourceVersion) : this.versionValue = this.vValue
    console.log(this.multipleSelection)
    this.getList()
  },
  mounted () {
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    getArrEqual (arr1, arr2) { // 取出相同数据
      const newArr = []
      arr1.forEach(ele => {
        arr2.forEach(e => {
          if (ele.id === e.id) {
            newArr.push(e)
          }
        })
      })
      return newArr
    },
    getRowKeys (row) {
      return row.id
    },
    getList () {
      if (this.ids) {
        this.keysArr = this.ids.map(v => v.id)
      }
      const params = {
        params: {
          pageSize: this.listQuery.limit,
          pageNumber: this.listQuery.page,
          productKey: this.popData.productKey,
          moduleName: this.popData.module,
          moduleVersions: this.versionValue,
          deviceName: this.deviceInput
        }
      }
      if (params.params.moduleVersions && params.params.moduleVersions.length === 0) delete params.params.moduleVersions
      if (params.params.deviceName === '') delete params.params.deviceName
      getDevices(params).then(res => {
        this.versionTableData = res.data.data.data
        this.total = res.data.data.total
        if (this.ids) {
          this.$nextTick(() => {
            if (this.versionTableData.length && this.versionTableData.length > 0) {
              this.versionTableData.forEach(row => {
                if (this.keysArr.includes(row.id)) {
                  this.$refs.multipleTable.toggleRowSelection(row, true)
                }
              })
            }
          })
        }
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？', '提示', {
        closeOnClickModal: false
      })
        .then(_ => {
          this.$emit('closeDrawer')
        })
        .catch(_ => {})
        .finally(_ => {
          // this.$parent.focusStatus = true
        })
    },
    selChange (val) {
      this.listQuery.page = 1
      this.getList()
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.drawerDemand()
      }
    },
    // 搜索
    drawerDemand () {
      this.listQuery.page = 1
      this.getList()
    },
    // table栏val选择的时间
    handleSelectionChange (val) {
      console.log(val)
      this.multipleSelection = val
      this.count = this.multipleSelection.length
    },
    confirm () {
      const deviceList = []
      const versionList = []
      console.log(this.multipleSelection)
      this.multipleSelection.forEach((item, index) => {
        versionList.push(item.moduleVersion)
        deviceList.push({ deviceName: item.deviceName, id: item.id, productKey: item.productKey, deviceVersion: item.moduleVersion })
      })
      /* const deviceList = []
      this.multipleSelection.forEach(item => {
        deviceList.push(item.deviceName)
      }) */
      this.versionValue = versionList
      const data = {
        version: this.versionValue,
        deviceList: deviceList
      }
      this.listQuery.page = 1
      this.$emit('getChildData', data)
      this.$emit('closeDrawer')
      /* this.drawerFlag = false
      this.$parent.focusStatus = false
      setTimeout(() => {
        this.$parent.focusStatus = true
      }, 0) */
      // 父子传值过去  id作为唯一标识
    },
    cancel () {
      this.handleClose()
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped>
.drawer{
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    /deep/ .el-drawer__body{
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .container{
        margin-bottom: 64px;
        padding: 16px 24px 0 24px !important;
        border-top: 1px solid #ececec;
        .screen{
          display: flex;
          margin-bottom: 20px;
          /deep/ .el-input{
            margin-left: 0;
            width: 90%;
          }
        }
        /deep/ .el-table::before{
          background: white;
        }
        /deep/ .el-table th>.cell:first-child{
          padding: 0 14px
        }
        /* .cell:first-child{

        } */
      }
      .drawer-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        margin-top: 10px;
        padding: 10px 24px ;
        height:64px;

        position: fixed;
        bottom: 0;
        /* display: block; */
        background: white;
        z-index: 10000;
        width: 100%;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
    }
    /deep/ :focus {
      outline: 0;
    }
  }
</style>
